"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Properties"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logger = function Logger(callerType) {
  function print(
  /*String*/
  message) {
    if (window.console) console.log(callerType + ' ' + message);
  }

  return {
    debug: function debug(
    /*String*/
    message) {
      if (_amb.default.logLevel === 'debug') print('[DEBUG] ' + message);
    },
    addInfoMessage:
    /*void*/
    function addInfoMessage(
    /*String*/
    message) {
      print('[INFO] ' + message);
    },
    addErrorMessage:
    /*void*/
    function addErrorMessage(
    /*String*/
    message) {
      print('[ERROR] ' + message);
    },
    addWarnMessage:
    /*void*/
    function addWarnMessage(
    /*String*/
    message) {
      print('[WARN] ' + message);
    }
  };
};

var _default = Logger;
exports.default = _default;